import { useRegisterSW } from 'virtual:pwa-register/react';

/**
 * Zeigt einen Hinweis, wenn eine neue Version bereitsteht.
 * Bewusst kein Auto-Reload: das wuerde eine laufende Bedienung unterbrechen.
 */
export function ReloadPrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();

  if (!needRefresh) return null;

  return (
    <div className="reload-prompt" role="alert">
      <span>Neue Version verfügbar.</span>
      <button type="button" onClick={() => void updateServiceWorker(true)}>
        Aktualisieren
      </button>
      <button type="button" onClick={() => setNeedRefresh(false)}>
        Später
      </button>
    </div>
  );
}
